import React from 'react';

interface Props {}

interface State {}

class VendorSummaryReports extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {};
    }
    render() {
        return <div>Vendor Summary Reports</div>;
    }
}

export default VendorSummaryReports;
